import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const sponsorMasterService = createApi({
    reducerPath: 'sponsorMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Sponsor'],
    endpoints: (builder) => ({
        getAllSponsorMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.getAllSponsorMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getSponsorMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.getSponsorMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveSponsorMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.saveSponsorMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateSponsorMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.updateSponsorMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteSponsorMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.deleteSponsorMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllSponsorMasterBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.sponsorMasterController.getAllSponsorMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllSponsorMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.findAllSponsorMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveSponsorMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.sponsorMasterController.bulkSaveSponsorMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllSponsorMasterMutation,
    useGetSponsorMasterByIdMutation,
    useSaveSponsorMasterMutation,
    useUpdateSponsorMasterMutation,
    useDeleteSponsorMasterMutation,
    useGetAllSponsorMasterBySearchMutation,
    useFindAllSponsorMasterMutation,
    useBulkSaveSponsorMasterMutation,
} = sponsorMasterService;